module.exports = __webpack_public_path__ + "img/scene1.0b8f448e.png";